import * as React from "react"
import { useEffect } from "react"
import { useValidatorSeeker } from "@ui-seeker/app"
import { object, string } from "yup"

import { CATALOGUE_ROUTES } from "@constants"
import { CommonFilters, CommonFiltersCatalogue } from "@components"
import { useAppDefaultFilters } from "@hooks"
import { isLoadingCommonFilters, disabledCommonFiltersSubmit, country } from "@signals"
import { CatalogueDetailsIsEmpty } from "./@signals"



export default function AnalyticsGeneralFilters() {

    useEffect(() => {	
		isLoadingCommonFilters.value = false
	},[])


	return <CommonFilters
		components={{
			onlySingleDate: true,
		}}
		compProps={{
			currentSingleDate: { grid: { md: 12 } },
		}}
		onSubmit={() => {
			isLoadingCommonFilters.value = true
		}}
	/>
}